import React  from 'react';
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";

//Layout
import AdminLayout from "./layouts/Admin";
import AuthLayout from "./layouts/Auth";

//Components
import Loading from './components/Loading/Loading';

//Context
import { useAuth } from './context/auth';

const hist = createBrowserHistory();

export default function RoutesComponent() {
    const { session, loading } = useAuth();
    return (
        <Router history={hist}>
            {loading && <Loading />}
            <Switch>
                <Route exact path="/" render={() => <Redirect to="/auth/login" />} />
                {session &&
                    <Route path="/admin" render={(props) => <AdminLayout {...props} />} />
                }
                <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
            </Switch>
        </Router>
    );
  
}
